// API configuration
import { getBackendUrl } from './env';

/**
 * Get the backend API URL at runtime
 * This function should be called at runtime, not at module load time,
 * to ensure window._env_ is populated with the correct values.
 * @returns {string} Full API URL (e.g., 'https://api.magic-moments.ai/api')
 */
export function getAPI() {
  const backendUrl = getBackendUrl();
  return `${backendUrl}/api`;
}

/**
 * Get backend URL - wrapper for compatibility
 * @returns {string} Backend URL
 */
export function getBACKEND_URL() {
  return getBackendUrl();
}

// Create a special object that acts like a string but calls getAPI() when converted
const createDynamicString = (fn) => {
  const obj = {
    toString: () => fn(),
    valueOf: () => fn(),
    // Make it work with template literals
    [Symbol.toPrimitive]: () => fn(),
    // Make it work with + operator
    concat: (str) => fn() + str
  };
  return obj;
};

// Export dynamic values that update at runtime
export const API = createDynamicString(getAPI);
export const BACKEND_URL = createDynamicString(getBACKEND_URL);
